import React, { useEffect, useState } from "react";
import axios from "axios";
import DocTable from "./DocTable";

const FirmDoc = () => {
  const [firms, setFirms] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedFirm, setSelectedFirm] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFirms();
  }, []);

  const fetchFirms = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/get-firms`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setFirms(res.data.firms); // ✅ Ensure you're saving array
    } catch (error) {
      console.error("Failed to load firms", error);
    } finally {
      setLoading(false);
    }
  };

  if (selectedFirm) {
    return (
      <div>
        <h4 className="text-center text-primary mb-4">
          Documents for:{" "}
          <span className="text-success">{selectedFirm.firmName}</span>
        </h4>
        <DocTable firmName={selectedFirm.firmName} />
        <div className="text-center mt-4">
          <button
            className="btn btn-secondary"
            onClick={() => setSelectedFirm("")}
          >
            Back to Firm List
          </button>
        </div>
      </div>
    );
  }

  const filteredFirms = firms.filter((firm) =>
    firm.firmName.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="container mt-4">
      <div className="card shadow-lg p-4 bg-light">
        <h2 className="text-success text-center mb-3">Your Firms</h2>
        <input
          type="text"
          placeholder="Search by Firm Name"
          className="form-control mb-4"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        {loading ? (
          <p className="text-center text-muted">Loading firms...</p>
        ) : filteredFirms.length === 0 ? (
          <p className="text-center text-danger">No firms found.</p>
        ) : (
          <div className="row">
            {filteredFirms.map((firm, idx) => (
              <div key={idx} className="col-md-4 mb-3">
                <div
                  className="card shadow border-0 bg-white text-center p-4"
                  onClick={() => setSelectedFirm(firm)}
                  style={{ cursor: "pointer" }}
                >
                  <h5 className="text-primary fw-bold">{firm.firmName}</h5>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default FirmDoc;
